export enum GuestStatus {
  Archived = -2,
  Cancelled = -1,
  Created = 0,
  Accepted = 2,
  Declined = 3,
  CheckedIn = 4,
  CheckedOut = 5,
}
